var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-block border border-gray text-14 text-black py-8 px-12 normal-case"},[_vm._t("default"),_vm._v(" "),_c('button',_vm._g({staticClass:"w-12 h-12 focus:outline-none text-center text-dark-gray ml-16"},_vm.triggers),[_c('i',{staticClass:"fal fa-times"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }